"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordeonButton = exports.AccordeonComponent = void 0;
var accordeon_1 = require("./accordeon");
Object.defineProperty(exports, "AccordeonComponent", { enumerable: true, get: function () { return accordeon_1.AccordeonComponent; } });
var accordeon_button_1 = require("./accordeon-button");
Object.defineProperty(exports, "AccordeonButton", { enumerable: true, get: function () { return accordeon_button_1.AccordeonButton; } });
